import PubSub from 'pubsub-js';

const $content = $('.juryContent');
PubSub.subscribe('init', () => {
    $('.card', $content).each((_key, element) => {
        $('.more', element).on('click', () => {
            $('.textarea', element).addClass('-more');
        });
    });
});